import Vue from 'vue';
export const event_bus = new Vue({
  methods: {
    emit_side_drawer({ component_name, component_func, component_params, title_suffix }) {
      this.$emit('emit_side_drawer', {
        component_name,
        component_func,
        component_params,
        title_suffix,
      });
    }
  }
});
